<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <v-btn v-if="inEditMode && rank.id != 0" class="ml-2 mr-2" color="primary" @click="saveClick(false)">
                    <v-icon small>fa-save</v-icon>&nbsp;{{ $t('buttons.save') }}
                </v-btn>
                <v-btn v-if="inEditMode" class="ml-2 mr-2" color="primary" @click="saveClick(true)">
                    <v-icon small>fa-save</v-icon>&nbsp;{{ $t('buttons.saveAndExit') }}
                </v-btn>
                <v-btn v-if="!inEditMode" class="ml-2 mr-2" color="primary" @click="editClick()">
                    <v-icon small>fa-edit</v-icon>&nbsp;{{ $t('buttons.edit') }}
                </v-btn>
                <v-btn class="mr-2" @click="backClick">
                    <v-icon small>fa-reply</v-icon>&nbsp;{{ $t('buttons.back') }}
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" xl="3" lg="4" md="6">
                <v-card flat outlined>
                    <v-card-text>
                        <v-row dense wrap>
                            <v-col cols="12">
                                <CheckBox
                                    :readonly="!inEditMode"
                                    v-model="rank.active"
                                    :label="$t('fields.active')"
                                ></CheckBox>
                            </v-col>
                            <v-col cols="12">
                                <InputField
                                    :maxlength="50"
                                    :readonly="!inEditMode"
                                    v-model="rank.name"
                                    :errorBorder="!rankValidation.name"
                                    :label="'* ' + $t('fields.name')"
                                ></InputField>
                            </v-col>
                            <v-col cols="12">
                                <InputField
                                    :maxlength="10"
                                    :readonly="!inEditMode"
                                    v-model="rank.abbreviation"
                                    :errorBorder="!rankValidation.abbreviation"
                                    :label="'* ' + $t('fields.abbreviation')"
                                ></InputField>
                            </v-col>
                            <v-col cols="12">
                                <Dropdown
                                    :readonly="!inEditMode"
                                    v-model="rank.rank_category_id"
                                    :ajax="true"
                                    :data="'rank-categories'"
                                    :errorBorder="!rankValidation.rank_category_id"
                                    :label="'* ' + $t('fields.category')"
                                ></Dropdown>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import CheckBox from './trinkets/CheckBox';
import Dropdown from './trinkets/Dropdown';
import InputField from './trinkets/InputField';
import Rank from '../models/Rank';

export default {
    name: 'Rank',
    components: {CheckBox, Dropdown, InputField},
    data: function () {
        return {
            rank: new Rank({id: this.$route.params.id}),
            rankValidation: new Rank({}, true),
            initialLoad: false,
            inEditMode: false,
            lockKey: 'rank',
            lockTimer: null,
        };
    },
    methods: {
        editClick() {
            let vm = this;
            this.$setLock(this, this.lockKey + '|' + this.rank.id, (data) => {
                if (data.success) {
                    vm.inEditMode = true;
                    vm.lockTimer = setInterval(() => {
                        vm.$setLock(vm, vm.lockKey + '|' + vm.rank.id);
                    }, 10000);
                } else {
                    vm.$alert(
                        this.$t('alerts.recordLocked')
                            .split('%name%')
                            .join(data.locked_by.first_name + ' ' + data.locked_by.last_name),
                    );
                }
            });
        },

        backClick() {
            this.$router.go(-1);
        },
        saveClick(goBack) {
            let success = true;
            if (this.rank.name == '') {
                success = false;
                this.rankValidation.name = false;
            } else {
                this.rankValidation.name = true;
            }
            if (this.rank.abbreviation == '') {
                success = false;
                this.rankValidation.abbreviation = false;
            } else {
                this.rankValidation.abbreviation = true;
            }

            if (this.rank.rank_category_id == null) {
                success = false;
                this.rankValidation.rank_category_id = false;
            } else {
                this.rankValidation.rank_category_id = true;
            }
            if (success) {
                let vm = this;
                let action = 'post';
                let addition = '';
                if (vm.rank.id != 0) {
                    action = 'put';
                    addition = '/' + vm.rank.id;
                }
                this.$APICall(action, 'ranks' + addition, this.rank, (data, success) => {
                    if (success) {
                        vm.inEditMode = false;
                        if (vm.rank.id == 0) {
                            vm.$notify(vm.$t('alerts.basicAdd'));
                        } else {
                            vm.$notify(vm.$t('alerts.basicUpdate'));
                        }
                        if (this.lockTimer !== null) clearInterval(this.lockTimer);
                        vm.$removeLock(vm, vm.lockKey + '|' + vm.rank.id);
                        vm.$triggerReload();
                        if (goBack) {
                            vm.backClick();
                        }
                    }
                });
            }
        },
    },

    watch: {
        'rank.abbreviation': {
            handler: function () {
                this.rank.abbreviation = this.rank.abbreviation.toUpperCase();
            },
            deep: true,
        },
    },
    beforeRouteLeave(to, from, next) {
        if (this.inEditMode) {
            let vm = this;
            this.$verify(this.$t('alerts.leaveQuestion'), (result) => {
                if (result) {
                    if (vm.lockTimer !== null) clearInterval(this.lockTimer);
                    this.$removeLock(this, this.lockKey + '|' + this.rank.id);
                    next(true);
                } else {
                    next(false);
                }
            });
        } else {
            next(true);
        }
    },
    mounted() {
        if (!this.$myStore.state.loggedIn) {
            this.$router.replace('login');
        }
        let vm = this;
        if (this.rank.id != 0) {
            this.$APICall('get', 'ranks/' + this.rank.id, {}, (data, success) => {
                if (success) {
                    let usableData = JSON.parse(JSON.stringify(data));
                    vm.rank = usableData;
                    vm.$myStore.commit('setBreadcrumbs', [
                        {
                            text: vm.$t('modules.documentTypes'),
                            href: '/#/ranks',
                            disabled: false,
                        },
                        {
                            text: vm.rank.name,
                            href: '/#/ranks/' + vm.rank.id,
                            disabled: true,
                        },
                    ]);
                    vm.$nextTick(() => {
                        vm.initialLoad = true;
                    });
                }
            });
        } else {
            this.$myStore.commit('setBreadcrumbs', [
                {
                    text: this.$t('modules.ranks'),
                    href: '/#/ranks',
                    disabled: false,
                },
                {
                    text: this.$t('modules.newRank'),
                    href: '/#/rank/0',
                    disabled: true,
                },
            ]);
            this.inEditMode = true;
            this.initialLoad = true;
        }
    },
};
</script>

<style scoped></style>
